export const PREVIEW_RESET_NOTICE_MESSAGE =
  '一定時間過ぎたため、リセットしました。お手数おかけしますが、再度コメントしてキャンペーンに参加してください。' /** todo: RESET_NOTICE_MESSAGEとの共通化を検討する. */
export const PREVIEW_UNFOLLOW_REPLY = 'いいえ'
export const PREVIEW_FOLLOW_REPLY = 'はい'
export const PREVIEW_MISSING_DATE_FIRST = '1月1日 00:00'
export const PREVIEW_MISSING_DATE_SECOND = '1月2日 00:00'

/**
 * メッセージ描画コントロール
 **/
export const PREVIEW_STEP_INTERVAL_MS = 800
export const PREVIEW_STEP_INTERVAL_SEC_MIN = 0.6
export const PREVIEW_STEP_INTERVAL_SEC_MAX = 1.6
export const PREVIEW_STEP_INTERVAL_SEC_STEP = 0.2
